import React from 'react';
import styles from './index.less';
import logo from "../../asset/img/login/logo.png";
import { useSelector } from 'react-redux';
import { matchPath } from 'react-router-dom';
import { targetLink } from 'utils/index';
const Head = () => {
  
  const routes = useSelector<any, any>((state) => state.routes);
  const onClickOpen = async (url?: any) => {
    targetLink(url, (_url:string) => window.open(_url));
  };
  const path = window.location.pathname;
  return (
    <div className={styles.title}>
    <img
      src={logo}
      onClick={() => {
        onClickOpen();
      }}
    />
    <p
      key='/'
      data-a-href="/"
      data-a-nofollow="true"
      onClick={() => {
        onClickOpen();
      }}
      className={matchPath(window.location.pathname, {
        path: "/",
        exact: true,
        strict: true
      }) ? styles.active : ''}
    >
      首页
    </p>
    {
      routes.map((item: any) => {
        return item.navShow ? (
          <p
            key={item.pathname}
            data-a-href={item.homeUrl}
            data-a-nofollow="true"
            onClick={() => {
              onClickOpen(item.homeUrl);
            }}
            className={matchPath(window.location.pathname, {
              path: item.pathname,
              exact: item.exact,
              strict: item.strict
            }) ? styles.active : ''}
          >
            {item.name}
          </p>
        ) : (<React.Fragment key={item.pathname}></React.Fragment>)
      })
    }
  </div>
  )
}
export default Head;